import {
  CanActivateFn,
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { inject } from "@angular/core";

import { AuthService } from "../api/auth.service";
import { CookiesService } from "../services/cookies.service";

export const LoggedInGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const cookiesService = inject(CookiesService);

  const cookieAccessToken = cookiesService.get("token");

  if (!auth.getToken() && !cookieAccessToken) {
    router.navigate(["/login"], { queryParams: { returnUrl: state.url } });
    return false;
  }
  return true;
};
